<h2 mat-dialog-title>Enter Tracking Information</h2>
<mat-dialog-content>
  <p class="tracking-dialog__hint">
    Choose the carrier you used and enter the tracking number. You can then notify the winner.
  </p>

  <div class="row mb-3">
    <div class="col-md-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Carrier</mat-label>
        <mat-select [(ngModel)]="selectedOptionId" name="carrier" required>
          <mat-option *ngFor="let option of shippingOptions" [value]="option.id">
            {{ option.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-md-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Tracking Number</mat-label>
        <input matInput [(ngModel)]="trackingId" name="trackingId" placeholder="Tracking number" required>
      </mat-form-field>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-md-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Shipped On</mat-label>
        <input matInput [matDatepicker]="shippedPicker" [(ngModel)]="shippedOn" name="shippedOn">
        <mat-datepicker-toggle matSuffix [for]="shippedPicker"></mat-datepicker-toggle>
        <mat-datepicker #shippedPicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-md-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Shipping Cost (optional)</mat-label>
        <input matInput type="number" min="0" step="0.01" [(ngModel)]="shippingPrice" name="shippingPrice">
        <span matPrefix>$&nbsp;</span>
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()" [disabled]="isSaving">Cancel</button>
  <button mat-raised-button color="primary" type="button" (click)="save()" [disabled]="!canSave">
    {{ isSaving ? 'Saving…' : 'Save Tracking' }}
  </button>
</mat-dialog-actions>
